/* lua.js generated code undefined */

/*     正交分组

    关于正交分组的设计及算法，详见文档：https://docs.google.com/document/d/1KSFwQJ8X081Q9xC6mXJ2jJf22zN3BTWSfzaZlgZUY5Q/edit#

    author: 张力 jay.zhang
    time: 2020-09-22 11:43:30
 */
require("clover/orthogonalGroup/OrthUserTagHelper")
const Event = require("cocos/framework/components/event")
OrthStrategyHelper = xClass("OrthStrategyHelper", Event)
let StrategyValueType = table.const(table(
    [1, "Unknown", -1],
    [1, "Number", 0],
    [1, "Discrete", 1],
    [1, "Range", 2]
))
let _instance = null
OrthStrategyHelper.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = OrthStrategyHelper.new()
    }
    return _instance
}
OrthStrategyHelper.prototype.ctor = function () {
    let self = this
    // 正交策略配置
    self.orthStrategyMeta = UserTagData.getInstance().orthapplyConfig;// MetaManager.getInstance().orthStrategy.items
}
/*     @desc: 检查该策略下是否满足所有标签条件
    --@strategyId: test_detail表中的id
    @return: 是否满足所有标签条件(true/false)
 */
OrthStrategyHelper.prototype.checkStrategy = function (strategyId) {
    let self = this
    console.log("\n-----开始detail检查【" + strategyId + "】");
    // QAGUILogger.getInstance().print("\n-----开始detail检查【" + strategyId + "】", "orth")
    let item = self.orthStrategyMeta[tonumber(strategyId)]
    if (item) {
        for (let key in item) {
            let value = item[key]
            if ($null(value)) continue
            if (key != "id" && key != "metaId" && value != "") {
                // 查询用户标签
                let funcName = "getUserTag_" + key
                if (!OrthUserTagHelper.getInstance()[funcName]) {
                    console.log("OrthUserTagHelper并未实现此方法: " + funcName);
                    // QAGUILogger.getInstance().print("OrthUserTagHelper并未实现此方法: " + funcName, "orth")
                } else {
                    let tagValue = OrthUserTagHelper.getInstance()[funcName]()
                    let success = self._checkValue(value, tagValue, key)
                    if (key === "LevelAreaRealTimeTag") {
                        let maxValue = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
                        console.log("maxLevel: " + maxValue);
                        // QAGUILogger.getInstance().print("maxLevel: " + maxValue, "orth")
                    }
                    console.log("检查标签[" + key + "], 目标值: " + value + ", 用户值: " + tagValue + ", 结果: " + tostring(success));
                    // QAGUILogger.getInstance().print("检查标签[" + key + "], 目标值: " + value + ", 用户值: " + tagValue + ", 结果: " + tostring(success), "orth")
                    if (!success) {
                        console.log("-----结束detail检查【" + strategyId + "】结果：false");
                        // QAGUILogger.getInstance().print("-----结束detail检查【" + strategyId + "】结果：false", "orth")
                        return false
                    }
                }
            }
        }
        console.log("-----结束detail检查【" + strategyId + "】结果：true");
        // QAGUILogger.getInstance().print("-----结束detail检查【" + strategyId + "】结果：true", "orth")
        return true
    }
    console.log("-----结束detail检查【" + strategyId + "】结果：false");
    // QAGUILogger.getInstance().print("-----结束detail检查【" + strategyId + "】结果：false", "orth")
    return false
}
/*     @desc: 检查值是否相等/被包含/处在范围内
    --@p: 匹配值
    --@v: 要检查的目标值
    --@key: 要检查的类型
    @return: 是否包含(true/false)
 */
OrthStrategyHelper.prototype._checkValue = function (p, v, key) {
    let self = this
    p = string.trim(p)
    let beginChar = string.sub(p, 1, 1)
    let endChar = string.sub(p, $len(p), $len(p))
    let patternType = StrategyValueType.Unknown
    if (tonumber(p) != null && $len(string.split(p, ",")) == 1) {
        patternType = StrategyValueType.Number
    } else if ((beginChar == "[" || beginChar == "(") && (endChar == "]" || endChar == ")")) {
        patternType = StrategyValueType.Range
    } else {
        patternType = StrategyValueType.Discrete
    }
    if (patternType === StrategyValueType.Number) {
        return tonumber(p) === tonumber(v)
    } else if (patternType === StrategyValueType.Discrete) {
        let set = string.split(p, ",")
        for (const k in set) {
            let d = set[k];
            if (d){
                set[k] = set[k].replace(/\s+/g, "")
            }
        }
        let result = table.exist(set, tostring(v))
        return result
    } else if (patternType === StrategyValueType.Range) {
        let str = string.sub(p, 2, $len(p) - 1)
        let spStr = string.split(str, ",")
        let min = self._convertRangeValue(spStr[1], key)
        let max = self._convertRangeValue(spStr[2], key)
        let eqMin = false
        if (beginChar == "[") {
            eqMin = (v == min)
        }
        let eqMax = false
        if (endChar == "]") {
            eqMax = (v == max)
        }
        let result = (v > min || eqMin) && (v < max || eqMax)
        return result
    }
}
OrthStrategyHelper.prototype._convertRangeValue = function (minmaxStr, key) {
    let self = this
    let ret = 0
    if (minmaxStr.indexOf("inf") != -1) {
        // ret = tonumber(minmaxStr)
        ret = Infinity
    } else if (minmaxStr.indexOf("max") != -1) {
        if (key === "LevelAreaRealTimeTag") {
            let maxValue = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
            minmaxStr = minmaxStr.replace("max", tostring(maxValue))
            // minmaxStr = "return " + minmaxStr
            // let f = loadstring(minmaxStr)
            // if (f) {
            //     ret = f()
            // }
            if (minmaxStr.indexOf("-") != -1){
                let s = minmaxStr.split("-");
                ret = tonumber(s[0]) - tonumber(s[1]);
            }else if (minmaxStr.indexOf("+") != -1){
                let s = minmaxStr.split("+");
                ret = tonumber(s[0]) + tonumber(s[1]);
            }
        }
    } else {
        ret = tonumber(minmaxStr)
    }
    return ret
}
